import { apiFetcher } from '~/apis/api-fetcher';

import { ProductDetailResponse } from './models';

export type ProductDetailParams = {
  pid: number;
  viewerUid?: number;
};

/** 메루카리 상품 상세 조회 */
export const getProductDetail = ({ pid, ...params }: ProductDetailParams, requestInit?: RequestInit) =>
  apiFetcher.get<ProductDetailResponse>(`/api/pms/v1/mercari/products-detail/${pid}`, params, requestInit);
